import { render, staticRenderFns } from "./MercadoDestinoBoletimSanitario.vue?vue&type=template&id=33bc844e&scoped=true&"
import script from "./MercadoDestinoBoletimSanitario.vue?vue&type=script&lang=js&"
export * from "./MercadoDestinoBoletimSanitario.vue?vue&type=script&lang=js&"
import style0 from "./MercadoDestinoBoletimSanitario.vue?vue&type=style&index=0&id=33bc844e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc844e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
